export default __webpack_public_path__ + "static/media/filled.9300343f.svg";